// extracted by mini-css-extract-plugin
export default {"f":"_5766dbfa87","main":"_3817815840","btn":"_55bed643d4","w":"b55fb3042b","h":"c18d3d3066","lh25":"_08dbdb28c4","wb":"a25cbdf85a","b":"_399deb6b99","bx":"_169657e4a8"};